import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { generateQuestion } from './GptQuestionGenerateApi';

export interface IGptQuestionGenerateState {
  status: 'idle' | 'loading' | 'rejected';
  question?: string;
  threadId?: string;
}

const initialState: IGptQuestionGenerateState = {
  status: 'idle',
  question: undefined,
  threadId: undefined,
};

export const GptQuestionSlice = createSlice({
  name: 'gptQuestionGenerate',
  initialState,
  reducers: {
    reset: (state, action) => {
      state.status = 'idle';
      state.question = undefined;
      state.threadId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateQuestion.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(generateQuestion.fulfilled, (state, action) => {
        state.status = 'idle';
        state.question = action.payload.message;
        if (action.payload.threadId) {
          state.threadId = action.payload.threadId;
        } else {
          state.threadId = undefined;
        }
      })
      .addCase(generateQuestion.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getGptQuestionGenerateState = (
  state: RootState
): RootState['gptQuestionGenerate'] => state.gptQuestionGenerate;

export const { reset } = GptQuestionSlice.actions;

export * from './GptQuestionGenerateApi';
export default GptQuestionSlice.reducer;
